import * as React from "react";
import { Button } from "react-bootstrap";
import { ActivityWithBrand } from "../../../../../../../../server/models/activity";
import { ConceptType } from "../../../../../../../../server/models/concept";
import { Job } from "../../../../../../../../server/models/job";
import {
	CurrentProductData,
	GetSimulationV3Response,
} from "../../../../../../../../server/types/request/report/simulation";
import { CorrectionValueSetting, CorrectionValueSettingProps } from "../correction-value";
import { SimulationResult } from "../result/index";
import { ElementEvaluation } from "../../../../../../../../server/models/graph/element-evaluation";
import { getAnalyticsVersion, overTagetVersion } from "../../../../../../lib/action-standard";
import { normRankExplain } from "../../../../../parts/graph/norm";
import { NormTableVersion5 } from "../norm-table/v5";
import { NormTable } from "../norm-table";
import {
	SimulationPredictionData,
	SimulationReferenceSourceData,
} from "../../../../../../../../server/types/request/simulation";

export type SimulationOneProps = {
	evaluations: ElementEvaluation[];
	job: Job;
	activity: ActivityWithBrand;
	target: "test1" | "test2";
	onSimulation: () => void;
	onSimulationSave: () => void;
	onChangeRatio: CorrectionValueSettingProps["onChangeRatio"];
	data: SimulationPredictionData;
	oneNumberScoreNorm: GetSimulationV3Response["oneNumberScoreNorm"];
	oneNumberScoreData: GetSimulationV3Response["oneNumberScoreData"];
	constValue: GetSimulationV3Response["constant"];
	referenceSourceData: SimulationReferenceSourceData;
	goalSalesVolume: number;
	maxRecognition: number;
	currentProduct?: CurrentProductData;
	hasEditRole: boolean;
	goalRecognitionRate: number;
};

export const SimulationOne = React.memo((props: SimulationOneProps) => {
	const {
		evaluations,
		hasEditRole,
		data,
		job,
		activity,
		target,
		oneNumberScoreNorm,
		oneNumberScoreData,
		goalSalesVolume,
		constValue,
		onSimulation,
		onSimulationSave,
		onChangeRatio,
		referenceSourceData,
		maxRecognition,
		currentProduct,
		goalRecognitionRate,
	} = props;
	// 相対パスだとサーバ側でよむことができないので、絶対パスで画像を読み込む必要がある。
	// const baseUrl = React.useMemo(() => location.origin, []);
	const version = React.useMemo(() => getAnalyticsVersion(job.endDatetime), [job]);
	const overVersion5 = React.useMemo(() => overTagetVersion(version, "v5"), [version]);
	const normExlpain = React.useMemo(() => {
		const v = getAnalyticsVersion(job.endDatetime);
		return normRankExplain[v];
	}, [job]);
	return (
		<>
			{hasEditRole && (
				<>
					<Button onClick={onSimulationSave} variant={"outline-secondary"} style={{ margin: "10px 0px" }}>
						保存
					</Button>
					<Button onClick={onSimulation} variant={"outline-secondary"} style={{ margin: "10px" }}>
						画像Download
					</Button>
				</>
			)}
			<table className={"simulation-table"}>
				<tr>
					<td className={"concept-title"}>提示コンセプト：{ConceptType[target]}</td>
					<td className={"jobno"}>
						JOB#: {job.jobNum}（{activity.category.name}、{activity.brand.name}）
					</td>
				</tr>
				<tr>
					<td className={"main"}>
						<div className={"image-area"}>
							<img src={data.conceptUrl} />
						</div>
					</td>
					<td className={"main all-result"}>
						<table className={"sub-table-2"}>
							<tbody>
								<tr>
									<td className="space"></td>
									<td className={"title-area"}>
										<div className="rotate-label">主要指標</div>
									</td>
									<td className="space"></td>
									<td>
										<div className={"graph-area"}>
											{overVersion5 ? (
												<NormTableVersion5
													target={target}
													evaluations={evaluations}
													oneNumberScoreNorm={oneNumberScoreNorm}
													oneNumberScoreData={oneNumberScoreData}
													activity={activity}
													job={job}
												/>
											) : (
												<NormTable
													target={target}
													evaluations={evaluations}
													oneNumberScoreNorm={oneNumberScoreNorm}
													oneNumberScoreData={oneNumberScoreData}
													activity={activity}
													job={job}
												/>
											)}
											<div className={"explain"}>
												{`＊購入意向はTB,T2Bをウエイト処理したワンナンバースコアで表示/計算　＊ノームランクは、${normExlpain}${
													overVersion5 ? "" : "＝再テスト基準"
												}`}
											</div>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
						<hr className={"dashed"} />
						<table className={"sub-table-2"}>
							<tbody>
								<tr>
									<td className="space"></td>
									<td className={"title-area"}>
										<div className="rotate-label">推定CP（発売後12ヶ月）</div>
									</td>
									<td className="space"></td>
									<td>
										<div className={"graph-area"}>
											<CorrectionValueSetting
												hasEditRole={hasEditRole}
												maxRecognition={maxRecognition}
												correctionValue={data.correctionValue ?? {}}
												initLocalRatio={referenceSourceData.umi.gRatio_LocalOther}
												initInboundRatio={referenceSourceData.umi.gRatio_IBBY}
												onChangeRatio={onChangeRatio}
												goalRecognitionRate={goalRecognitionRate}
												gRepeat={referenceSourceData.buyPerYear.gRepeat}
											/>
											<SimulationResult
												goalRecognitionRate={goalRecognitionRate}
												correctionValue={data.correctionValue}
												currentProduct={currentProduct}
												data={data}
												referenceSourceData={referenceSourceData}
												goalSalesVolume={goalSalesVolume}
												constValue={constValue}
											/>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</td>
				</tr>
			</table>
		</>
	);
});
